import React from 'react';

import { useSelector } from 'react-redux';

import { BuildStatusProvider } from 'src/components/build-status-card/services/build-status-service/build-status-service';
import { Commit as CommitType } from 'src/components/types';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import urls from 'src/urls/source';

export const CommitBuildStatusProvider = ({
  commit,
  children,
}: {
  commit: CommitType;
  children: React.ReactNode;
}): JSX.Element => {
  const repositoryFullName = useSelector(getCurrentRepositoryFullSlug);

  let repositoryMetadataURL;
  let repositoryFullSlug;
  if (repositoryFullName) {
    repositoryFullSlug = repositoryFullName;
    repositoryMetadataURL =
      urls.api.internal.repositoryMetadataURL(repositoryFullName);
  }

  const url = new URL(commit.links.statuses.href);
  url.searchParams.set('pagelen', '100');

  return (
    <BuildStatusProvider
      repositoryFullSlug={repositoryFullSlug}
      buildStatusURL={url.toString()}
      repositoryMetadataURL={repositoryMetadataURL}
    >
      {children}
    </BuildStatusProvider>
  );
};
